import { h, Component } from "preact";
export default class CheckboxInputForm extends Component {
  toggle = (e) => {
    let checked = !this.state.checked;
    this.setState({ checked });
    this.props.onChange(checked);
  };

  render(_, { checked }) {
    return (
      <div>
        <input type="checkbox" checked={checked} onClick={this.toggle} />
        <span dangerouslySetInnerHTML={{ __html: this.props.label }}></span>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/Forms/CheckboxInput/index.js